function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Play/M/Default"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C20,14.1217319 19.1571453,16.1565632 17.6568542,17.6568542 C16.1565632,19.1571453 14.1217319,20 12,20 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.34,7.45 C11.8391189,6.98841249 11.1110814,6.87035235 10.49,7.15 C9.88669336,7.394048 9.49131828,7.97920312 9.49,8.63 L9.49,15.37 C9.49131828,16.0207969 9.88669336,16.605952 10.49,16.85 C10.7067765,16.9483165 10.9419708,16.9994457 11.18,17 C11.6089139,16.9980997 12.0220132,16.8378457 12.34,16.55 L16,13.18 C16.3309718,12.8769209 16.5194446,12.4487753 16.5194446,12 C16.5194446,11.5512247 16.3309718,11.1230791 16,10.82 L12.34,7.45 Z M11.5,14.6 L11.5,9.4 L14.31,12 L11.5,14.6 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}));

function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon_play.9e217c9c.svg";
export { ForwardRef as ReactComponent };